import { render, staticRenderFns } from "./RecipientDetail.vue?vue&type=template&id=cc6ef47a&"
import script from "./RecipientDetail.vue?vue&type=script&lang=js&"
export * from "./RecipientDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports